<template>
<!--Main contents-->
<div class="box_center" id="menu_index">
  <ul class="articles">
  <li v-if="user && user.admin">
    <router-link :to="{path: '/admin'}"><div class="img_left sprite process"></div></router-link>
    <div class="article">
    <router-link :to="{path: '/admin'}" class="title_article">Admin</router-link>
    </div>
    <div class="separator"></div>
  </li>
  <li v-if="!user || !user.admin">
  <router-link :to="{path: '/buy'}"><div class="img_left sprite dollar_currency_sign" title="Buy Picks"></div></router-link>
  <div class="article">
  <router-link :to="{path: '/buy'}" class="title_article">Buy Picks</router-link>
  </div>
  <div class="separator"></div>
  </li>
  <li>
  <router-link :to="{path: '/testimonials'}"><div class="img_left sprite user"></div></router-link>
  <div class="article">
  <router-link :to="{path: '/testimonials'}" class="title_article">Testimonials</router-link>
  </div>
  <div class="separator"></div>
  </li>
  <li>
  <router-link :to="{path: '/picks'}"><div class="img_left sprite lock" title="View Picks"></div></router-link>
  <div class="article">
   <router-link :to="{path: '/picks'}" class="title_article">View Picks</router-link>
  </div>
  <div class="separator"></div>
  </li>
<!--   <li>
  <router-link :to="{path: '/results'}"><div class="img_left sprite chart_up" title="Results"></div></router-link>
  <div class="article">
  <router-link :to="{path: '/results'}" class="title_article">Results</router-link>
  </div>
  <div class="separator"></div>
  </li> -->
  <li>
  <router-link :to="{path: '/tools/size'}"><div class="img_left sprite chart_up" title="tools"></div></router-link>
  <div class="article">
  <router-link :to="{path: '/tools/size'}" class="title_article">Bet Calculator</router-link>
  </div>
  <div class="separator"></div>
  </li>
  <li>
  <router-link :to="{path: '/myaccount'}"><div class="img_left sprite process" title="My Account"></div></router-link>
  <div class="article">
  <router-link :to="{path: '/myaccount'}" class="title_article">My Account</router-link>
  </div>
  <div class="separator"></div>
  </li>
  <li>
  <router-link :to="{path: '/blog'}"><div class="img_left sprite email" title="Blog"></div></router-link>
  <div class="article">
  <router-link :to="{path: '/blog'}" class="title_article">Blog</router-link>
  </div>
  <div class="separator"></div>
  </li>
  <li>
  <router-link :to="{path: '/contact'}"><div class="img_left sprite mail" title="Contact Us"></div></router-link>
  <div class="article">
  <router-link :to="{path: '/blog'}" class="title_article">Contact</router-link>
  </div>
  <div class="separator"></div>
  </li>
  <li>
  <router-link :to="{path: '/help'}"><div class="img_left sprite comment" title="Need Help?"></div></router-link>
  <div class="article">
  <router-link :to="{path: '/help'}" class="title_article">Help?</router-link>
  </div>
  <div class="separator"></div>
  </li>
  <li>
  <router-link :to="{path: '/shop'}"><div class="img_left shop-icon" title="Shop"></div></router-link>
  <div class="article">
  <router-link :to="{path: '/shop'}" class="title_article">Shop</router-link>
  </div>
  <div class="separator"></div>
  </li>
  </ul>
  </div>
  <!--Main contents Ends-->
</template>

<script>
export default {
  data () {
    return {

    }
  },
  created () {
    this.$store.dispatch('getStoredUser').then(() => {
      if (!this.$store.state.currentUser < 0) this.$router.push('/login')
    })
    this.$store.dispatch('getPackages')
  },
  computed: {
    user () {
      return this.$store.state.currentUser
    }
  }
}
</script>

<style lang="css" scoped>
.shop-icon {
  width: 128px;
  height: 128px;
  background-image: url('/static/images/shopping-cart.png') !important;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// Home.vue?1750ed21